import { useState, useEffect } from "react";
import { api } from "../App";
import { getApiPrefix } from "../utils/apiHelper";

// Re-export components from sub-modules
export { LayoutEditorDialog } from "./bilancio/LayoutEditorDialog";
export { VistaMargini } from "./bilancio/VistaMargini";

// Hook to load active layout
export function useActiveLayout() {
  const [activeLayout, setActiveLayout] = useState(null);
  const [layoutLoading, setLayoutLoading] = useState(false);

  const fetchActiveLayout = async () => {
    setLayoutLoading(true);
    try {
      const prefix = getApiPrefix();
      const res = await api.get(`${prefix}/bilancio-layouts`);
      const active = (res.data || []).find(l => l.attivo);
      setActiveLayout(active || null);
    } catch {
      setActiveLayout(null);
    } finally {
      setLayoutLoading(false);
    }
  };

  useEffect(() => { fetchActiveLayout(); }, []);

  return { activeLayout, setActiveLayout, fetchActiveLayout, layoutLoading };
}
